var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.5C-1.20706e-08 20.2238 0.223858 20 0.5 20H8.5C8.77614 20 9 20.2238 9 20.5C9 20.7761 8.77614 21 8.5 21H0.5C0.223858 21 1.20705e-08 20.7761 0 20.5Z",
    fill: "#27323C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 12C11.5 11.7239 11.7239 11.5 12 11.5H23.5C23.7761 11.5 24 11.7239 24 12C24 12.2762 23.7761 12.5 23.5 12.5H12C11.7239 12.5 11.5 12.2762 11.5 12Z",
    fill: "#27323C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C-1.20706e-08 11.7238 0.223858 11.5 0.5 11.5H5C5.27614 11.5 5.5 11.7238 5.5 12C5.5 12.2761 5.27614 12.5 5 12.5H0.5C0.223858 12.5 1.20706e-08 12.2761 0 12Z",
    fill: "#27323C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 3.49999C17 3.22384 17.2239 2.99999 17.5 2.99999H23.5C23.7761 2.99999 24 3.22384 24 3.49999C24 3.77613 23.7761 3.99999 23.5 3.99999H17.5C17.2239 3.99999 17 3.77613 17 3.49999Z",
    fill: "#27323C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.5C-1.20706e-08 3.22386 0.223858 3 0.5 3H10.5C10.7761 3 11 3.22386 11 3.5C11 3.77614 10.7761 4 10.5 4H0.5C0.223858 4 1.20705e-08 3.77614 0 3.5Z",
    fill: "#27323C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C13.7239 7 13.5 6.77614 13.5 6.5V0.5C13.5 0.223857 13.7239 5.40077e-10 14 0C14.2761 -5.40077e-10 14.5 0.223857 14.5 0.5V6.5C14.5 6.77614 14.2761 7 14 7Z",
    fill: "#27323C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.5C15.5 4.32843 14.8284 5 14 5C13.1716 5 12.5 4.32843 12.5 3.5C12.5 2.67157 13.1716 2 14 2C14.8284 2 15.5 2.67157 15.5 3.5Z",
    fill: "#27323C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C11.7239 24 11.5 23.7761 11.5 23.5V17.5C11.5 17.2239 11.7239 17 12 17C12.2761 17 12.5 17.2239 12.5 17.5V23.5C12.5 23.7761 12.2761 24 12 24Z",
    fill: "#27323C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.5C13.5 21.3284 12.8284 22 12 22C11.1716 22 10.5 21.3284 10.5 20.5C10.5 19.6716 11.1716 19 12 19C12.8284 19 13.5 19.6716 13.5 20.5Z",
    fill: "#27323C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 15.5C8.22386 15.5 8 15.2761 8 15L8 9C8 8.72386 8.22386 8.5 8.5 8.5C8.77614 8.5 9 8.72386 9 9V15C9 15.2761 8.77614 15.5 8.5 15.5Z",
    fill: "#27323C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12C10 12.8284 9.32843 13.5 8.5 13.5C7.67157 13.5 7 12.8284 7 12C7 11.1716 7.67157 10.5 8.5 10.5C9.32843 10.5 10 11.1716 10 12Z",
    fill: "#27323C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 20.5C15 20.2239 15.2239 20 15.5 20H23.5C23.7761 20 24 20.2239 24 20.5C24 20.7761 23.7761 21 23.5 21H15.5C15.2239 21 15 20.7761 15 20.5Z",
    fill: "#27323C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.8402f9e00ccc22721babc1c6d0f01959.svg";
export { ForwardRef as ReactComponent };